import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProfileStep from './ProfileStep';
import get from 'lodash/get'
import Box from '@material-ui/core/Box'
import Tooltip from '@material-ui/core/Tooltip'

import ValidationErrorMessage from '../../../shared/ValidationErrorMessage';
import Http from '../../../shared/http';
import toastr from 'toastr';

export default class CurrentBudgetStep extends ProfileStep {
  constructor(props) {
    super(props);
    this.currentNetIncome = props.stepConfig.currentNetIncome;
    this.currentMonthlyExpenses = props.stepConfig.currentMonthlyExpenses;

    this.state = {
      pristine: true,
      incomeErrorMessage: '',
      incomeValue: this.currentNetIncome,
      expenseErrorMessage: '',
      expenseValue: this.currentMonthlyExpenses,
      isSubmitting: false
    }
  }

  onNext = (e) => {
    e.preventDefault();
    let currentNetIncome = get('value', document.getElementById('profile_current_income'), 0);
    let currentMonthlyExpenses = document.getElementById('profile_current_monthly_expenses').value;

    let incomeIsValid = this.validate(currentNetIncome);
    let expenseIsValid = this.validate(currentMonthlyExpenses);

    if (incomeIsValid && expenseIsValid) {
      if (this.props.stepConfig.isRetired) {
        this.postResultsAndRedirect();
      } else {
        this.setRetirementBudgetAndProceed();
      }
    } else {
      this.setState({ pristine: false }, () => {
        if (!incomeIsValid) {
          this.setState({ incomeErrorMessage: `A value is required` })
        }
        if (!expenseIsValid) {
          this.setState({ expenseErrorMessage: `A value is required` })
        }
      });
    }
  }

  validate = (val) => {
    let isValid = val !== null && val !== '';

    return isValid;
  }

  handleChange = (e) => {
    e.preventDefault();
    let value, errorMessage;

    if (e.target.id === 'profile_current_income') {
      value = 'incomeValue'
      errorMessage = 'incomeErrorMessage'
    } else if (e.target.id === 'profile_current_monthly_expenses') {
      value = 'expenseValue'
      errorMessage = 'expenseErrorMessage'
    }

    this.setState({ [value]: e.target.value })
    if (!this.state.pristine && !this.validate(e.target.value)) {
      this.setState({ [errorMessage]: `A value is required` });
    } else {
      this.setState({ [errorMessage]: '' });
    }
  }

  postResultsAndRedirect() {
    let profile = {
      is_retired: this.props.stepConfig.isRetired,
      monthly_current_budget: document.getElementById('profile_current_monthly_expenses').value,
      gross_monthly_current_income: get('value', document.getElementById('profile_current_income'), 0),
    }

    let data = {
      profile
    };

    Http.request(`/clients/${this.props.stepConfig.clientId}/onboarding/profile/answers`, "POST", JSON.stringify(data)).then((response) => {
      if (response.ok) {
        return response.json().then((data) => {
          window.location = data.redirect_path;
        });
      } else {
        this.showErrorMessage("Your request failed, please try again.");
        this.setState({ isSubmitting: false });
      }
    }, function (error) {
      this.showErrorMessage("Sorry, a network error occured. Please try again.");
      this.setState({ isSubmitting: false });
    });
    this.setState({ isSubmitting: true });
  }

  setRetirementBudgetAndProceed() {
    const monthly_current_budget = document.getElementById('profile_current_monthly_expenses').value
    document.getElementById('profile_monthly_retirement_budget').value = monthly_current_budget;
    this.props.onNext();
  }

  showErrorMessage(message) {
    toastr.options.positionClass = 'toast-footer-small';
    toastr.warning(message);
  }

  onNextButton() {
    return <button className={"button profile-step__button qa-profile-current-budget"}
      disabled={this.state.isSubmitting}
      onClick={this.onNext}>
      {this.nextButtonText()}
    </button>;
  }

  nextButtonText() {
    if (this.state.isSubmitting) return "Loading...";
    if (this.props.stepConfig.isRetired) {
      return "Done";
    } else {
      return "Next";
    }
  }

  budgetFieldsLabel() {
    if (this.props.stepConfig.isRetired) {
      return (
        <p>Enter your current monthly expenses.</p>
      )
    }
    return (
      <p>This is your income <strong>before tax</strong> and your monthly expenses.</p>
    )
  }

  incomeField() {
    if (this.props.stepConfig.isRetired) return null

    return (
      <div className={`form-input string required profile_current_income has-floating-label is-half ${this.state.incomeErrorMessage.length > 0 ? 'has-error' : ''}`}>
        <label className="form-control profile_current_income">
          <div className="form-control__label">
            <span>Current monthly income (before tax)</span><abbr title="required">*</abbr>
          </div>
          <div className="form-control__input">
            <Tooltip title='This includes employer contributions to retirement funds'>
              <Box>
                <input onChange={this.handleChange} className="string required format-currency" required="required" aria-required="true" type="text" defaultValue={this.currentNetIncome} name={"profile[gross_monthly_current_income]"} id="profile_current_income" />
              </Box>
            </Tooltip>
          </div>
        </label>
        <ValidationErrorMessage errorMessage={this.state.incomeErrorMessage} />
      </div>
    )
  }

  render() {
    return (
      <div className="profile-step">
        <h1 className="profile-step__title">{`What are your monthly expenses?`}</h1>
        <div className="profile-step__content">
          <form className="simple_form js-onboarding-form onboarding__form" id="edit_profile_3" action="/onboarding/budget?next_path=%2Fonboarding%2Fbudget_calculated" acceptCharset="UTF-8" method="post">
            <input name="utf8" type="hidden" value="✓" />
            {this.budgetFieldsLabel()}
            <fieldset className="form__inputs flex flex-col md:block">
              {this.incomeField()}
              <div className={`form-input string required profile_current_monthly_expenses has-floating-label is-half ${this.state.expenseErrorMessage.length > 0 ? 'has-error' : ''}`}>
                <label className="form-control profile_current_monthly_expenses">
                  <div className="form-control__label">
                    <span>Current monthly expenses</span><abbr title="required">*</abbr>
                  </div>
                  <div className="form-control__input">
                    <input onChange={this.handleChange} className="string required format-currency" required="required" aria-required="true" type="text" defaultValue={this.currentMonthlyExpenses} name="profile[monthly_current_budget]" id="profile_current_monthly_expenses" />
                  </div>
                </label>
                <ValidationErrorMessage errorMessage={this.state.expenseErrorMessage} />
              </div>
            </fieldset>
          </form>
          <div className='flex flex-col gap-4 mr-12 xs:mr-auto xs:flex xs:flex-row'>
            {this.props.onBack && <button className="button button--secondary profile-step__button" onClick={this.onBack}>Back</button>}
            {this.onNextButton()}
          </div>
        </div>
      </div>
    )
  }
}
